/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NoteVM } from '../models/NoteVM';
import type { NoteVMIEnumerableResponseVM } from '../models/NoteVMIEnumerableResponseVM';
import type { NoteVMResponseVM } from '../models/NoteVMResponseVM';
import type { StringResponseVM } from '../models/StringResponseVM';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class NoteService {
    /**
     * @param organizationId
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns NoteVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiNoteOrganizationlist(
        organizationId: number,
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<NoteVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Note/{organizationId}/organizationlist',
            path: {
                'organizationId': organizationId,
            },
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
    /**
     * @param tenantId
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns NoteVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiNoteTenantlist(
        tenantId: number,
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<NoteVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Note/{tenantId}/tenantlist',
            path: {
                'tenantId': tenantId,
            },
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
    /**
     * @param propertyId
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns NoteVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiNotePropertylist(
        propertyId: number,
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<NoteVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Note/{propertyId}/propertylist',
            path: {
                'propertyId': propertyId,
            },
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
    /**
     * @param unitId
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns NoteVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiNoteUnitlist(
        unitId: number,
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<NoteVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Note/{unitId}/unitlist',
            path: {
                'unitId': unitId,
            },
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
    /**
     * @param userId
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns NoteVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiNoteUserlist(
        userId: number,
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<NoteVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Note/{userId}/userlist',
            path: {
                'userId': userId,
            },
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
    /**
     * @param contractorId
     * @returns NoteVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiNoteContractorlist(
        contractorId: number,
    ): CancelablePromise<NoteVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Note/{contractorId}/contractorlist',
            path: {
                'contractorId': contractorId,
            },
        });
    }
    /**
     * @param serviceRequestId
     * @returns NoteVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiNoteServicerequestlist(
        serviceRequestId: number,
    ): CancelablePromise<NoteVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Note/{serviceRequestId}/servicerequestlist',
            path: {
                'serviceRequestId': serviceRequestId,
            },
        });
    }
    /**
     * @param noteId
     * @returns NoteVMResponseVM Success
     * @throws ApiError
     */
    public static getApiNote(
        noteId: number,
    ): CancelablePromise<NoteVMResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Note/{noteId}',
            path: {
                'noteId': noteId,
            },
        });
    }
    /**
     * @param noteId
     * @returns StringResponseVM Success
     * @throws ApiError
     */
    public static deleteApiNote(
        noteId: number,
    ): CancelablePromise<StringResponseVM> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/Note/{noteId}',
            path: {
                'noteId': noteId,
            },
        });
    }
    /**
     * @param requestBody
     * @returns NoteVMResponseVM Success
     * @throws ApiError
     */
    public static postApiNote(
        requestBody?: NoteVM,
    ): CancelablePromise<NoteVMResponseVM> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Note',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns NoteVMResponseVM Success
     * @throws ApiError
     */
    public static putApiNote(
        requestBody?: NoteVM,
    ): CancelablePromise<NoteVMResponseVM> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/Note',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
